import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withKeys as _withKeys, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7c82e12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "file-btns" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = { class: "inputs" }
const _hoisted_5 = { style: {"flex":"auto"} }
const _hoisted_6 = { style: {"height":"500px","flex":"auto"} }


const __default__ = {
  name: 'OrderPlanProductDetail'
};

import { createVNode, ref, watch } from 'vue';
import { OioInput, OioSpin, OioTag, OioButton, OioNotification, OioMessage, OioModal } from '@kunlun/vue-ui-antd';
import { FullscreenExitOutlined, FullscreenOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { vxeTableBooleanFormatter } from '../../../../utils/fotmatter';
import { useFullscreen } from '../../../../hooks/fullscreen';
import { useProductPackage } from '../../../../hooks';
import { RuntimeModel, RuntimeO2MField } from '@kunlun/dependencies';
import { clickUploadExcelFile, exportExcelFile } from '../../../../utils/excel';
import { Modal } from 'ant-design-vue';

interface IProps {
  state: {
    tableLoading: boolean;
  };
  formData: any;
  change: (val) => void;
  mountedProcessFlag: boolean;
  rModel: RuntimeModel;
  _field: RuntimeO2MField;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    state: null,
    formData: null,
    change: null,
    mountedProcessFlag: { type: Boolean },
    rModel: null,
    _field: null
  },
  setup(__props: any, { emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props as { state: {
    tableLoading: boolean;
  }, formData: any, change: (val) => void, mountedProcessFlag: boolean, rModel: RuntimeModel, _field: RuntimeO2MField }




const { generateConvertRelationStr, convertToLargePackage } = useProductPackage();

const tableRef = ref<any>();
const contentRef = ref<HTMLElement | undefined>();
const { isFullscreen, toggleFullscreen } = useFullscreen(contentRef);

const searchStr = ref('');
const dataSource = ref<any[]>([]);
const displayTableData = ref<any[]>([]);
const exportLoading = ref(false);
const showErrorModal = ref(false);
const errorRows = ref<any[]>([]);

const importDataEvent = async (e) => {
  Modal.confirm({
    getContainer: () => document.getElementById('orderPlanProduct')!,
    class: 'oio-modal',
    title: '提示',
    content: '请使用导出的表格进行导入，该导入功能仅覆盖匹配行的本次要货数量！',
    icon: createVNode(ExclamationCircleOutlined),
    cancelText: '取消',
    okText: '开始导入',
    onOk: async () => {
      const data = await clickUploadExcelFile();
      if (!data || data.length === 0) {
        OioNotification.error('错误', '导入数据为空');
        return;
      }
      const keyMap = {
        ERP商品编码: 'itemOutCode',
        商品名称: 'itemName',
        是否赠品: 'isGifted',
        '已要货数量(Kar)': 'purchasingTotalNum',
        '已要货数量(PCS)': 'purchasingTotalNum',
        '剩余可要货数量(Kar)': 'unPurchasingTotalNum',
        '剩余可要货数量(PCS)': 'unPurchasingTotalNum',
        换算关系: 'itemSpecifications',
        '本次要货数量(PCS)': 'itemPurchasingNum'
      };
      // 检查表头是否完全匹配
      const header = Object.keys(data[0]);
      const keys = Object.keys(keyMap);
      if (!keys.every((key) => header.includes(key))) {
        OioNotification.error('错误', '导入数据表头不匹配，请使用导出的表格进行导入');
        return;
      }
      // 校验【ERP商品编码】必填
      if (data.some((i) => !i['ERP商品编码'])) {
        OioNotification.error('错误', '导入文件的【ERP商品编码】必填');
        return;
      }
      // 当【本次发货数量】大于「剩余可要货数量」时，记录所有错误行的行号、商品名称、错误原因，错误原因格式【XXXXX商品剩余可要货数量不足，请仔细核对】
      errorRows.value = data
        .filter((i, index) => {
          // const match = dataSource.value.find((j, index2) => !j.isGifted && j.itemOutCode == i['ERP商品编码']);
          // return match && i['本次要货数量(PCS)'] > match.unPurchasingTotalNum;
          return i['本次要货数量(PCS)'] > dataSource.value[index].unPurchasingTotalNum;
        })
        .map((i) => ({
          rowNum: i['行号'],
          itemName: i['商品名称'],
          errorMsg: '商品剩余可要货数量不足，请仔细核对'
        }));
      if (errorRows.value.length) {
        showErrorModal.value = true;
        return;
      }

      // 根据当前的dataSource每行的【ERP商品编码】进行匹配，只覆盖【本次要货数量】列
      dataSource.value.forEach((i, index) => {
        // const match = data.find((j) => j['ERP商品编码'] == i.itemOutCode);
        // if (match) {
        //   i.itemPurchasingNum = match['本次要货数量(PCS)'] || 0;
        // }
        i.itemPurchasingNum = data[index]['本次要货数量(PCS)'] || 0;
      });
      OioMessage.success('导入成功');
      errorRows.value = [];
    },
    onCancel() {}
  });
};

const exportDataEvent = () => {
  try {
    exportLoading.value = true;
    const fileData = dataSource.value.map((i, index) => ({
      行号: index + 1,
      ERP商品编码: i.itemOutCode,
      商品名称: i.itemName,
      是否赠品: i.isGifted ? '是' : '否',
      '已要货数量(Kar)': convertToLargePackage(i.purchasingTotalNum, 'PCS', 'KAR', i.itemSpecifications),
      '已要货数量(PCS)': i.purchasingTotalNum,
      '剩余可要货数量(Kar)': convertToLargePackage(i.unPurchasingTotalNum, 'PCS', 'KAR', i.itemSpecifications),
      '剩余可要货数量(PCS)': i.unPurchasingTotalNum,
      换算关系: generateConvertRelationStr(i.itemSpecifications),
      '本次要货数量(PCS)': i.itemPurchasingNum
    }));
    exportExcelFile(fileData, { filename: `要货明细${Date.now()}.xlsx` });
  } catch (error) {
    console.error(error);
  } finally {
    exportLoading.value = false;
  }
};

watch(
  dataSource,
  (value) => {
    if (props.mountedProcessFlag) {
      props.change(value);
    }
  },
  { deep: true }
);

const stop1 = watch(
  () => props.formData[props._field.name],
  (value) => {
    if (value?.length) {
      stop1();
    }
    dataSource.value = value ?? [];
  },
  { deep: true }
);

const updateDisplayTableData = () => {
  const oriData = dataSource.value;
  const keyList = searchStr.value.split(/[ \t\n]/).filter((s) => s);
  if (keyList.length === 0) {
    displayTableData.value = oriData;
  } else {
    displayTableData.value = oriData.filter((item) => {
      return keyList.length ? keyList.some((key) => ((item.productOutCode ?? '') + (item.itemName ?? '') + (item.itemOutCode ?? ''))?.includes?.(key)) : true;
    });
  }
};

// 注意有多处监听了dataSource
watch(
  [dataSource, searchStr],
  () => {
    updateDisplayTableData();
  },
  {
    immediate: true
  }
);

return (_ctx: any,_cache: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", {
    class: "content",
    id: "orderPlanProduct",
    ref_key: "contentRef",
    ref: contentRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: exportDataEvent,
            loading: exportLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: importDataEvent,
            loading: exportLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("导入")
            ]),
            _: 1
          }, 8, ["loading"]),
          _withDirectives(_createVNode(_unref(OioButton), {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showErrorModal.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看错误信息")
            ]),
            _: 1
          }, 512), [
            [_vShow, errorRows.value.length]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(OioInput), {
            value: searchStr.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchStr).value = $event)),
            placeholder: "按货号、商品名称、物料号搜索",
            style: {"width":"220px"},
            "allow-clear": ""
          }, null, 8, ["value"]),
          _createElementVNode("span", {
            style: {"font-size":"20px","margin-left":"10px","cursor":"pointer"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toggleFullscreen) && _unref(toggleFullscreen)(...args)))
          }, [
            (!_unref(isFullscreen))
              ? (_openBlock(), _createBlock(_unref(FullscreenOutlined), { key: 0 }))
              : (_openBlock(), _createBlock(_unref(FullscreenExitOutlined), { key: 1 }))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(OioSpin), {
        loading: __props.state.tableLoading
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_vxe_table, {
              "header-align": "center",
              border: "",
              ref_key: "tableRef",
              ref: tableRef,
              height: "auto",
              "keep-source": "",
              "column-config": { resizable: true },
              data: displayTableData.value,
              "edit-config": { trigger: 'click', mode: 'cell' },
              "scroll-x": { enabled: false },
              "scroll-y": { enabled: true, gt: 0, oSize: 20 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_column, {
                  type: "seq",
                  title: "行号",
                  fixed: "left",
                  width: "50"
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemName",
                  fixed: "left",
                  title: "商品名称",
                  width: "160"
                }),
                _createVNode(_component_vxe_column, {
                  field: "productOutCode",
                  fixed: "left",
                  title: "货号",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  title: "标签",
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.isAllocItem)
                      ? (_openBlock(), _createBlock(_unref(OioTag), {
                          key: 0,
                          bordered: false,
                          color: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.isAllocItem ? '分配品' : ''), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (scope.row.isAssemblyItem)
                      ? (_openBlock(), _createBlock(_unref(OioTag), {
                          key: 1,
                          bordered: false,
                          color: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.isAssemblyItem ? '子母件' : ''), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemOutCode",
                  title: "ERP商品编码",
                  "min-width": "150"
                }),
                _createVNode(_component_vxe_column, {
                  field: "materialGroupCode",
                  title: "物料号",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "isGifted",
                  title: "是否赠品",
                  width: "100",
                  formatter: _unref(vxeTableBooleanFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "orderItemNum",
                  title: "下单数量(PCS)",
                  width: "150"
                }),
                _createVNode(_component_vxe_column, {
                  field: "saleUnitName",
                  title: "单位",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  title: "已要货数量(KAR)",
                  width: "150"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(convertToLargePackage)(row.purchasingTotalNum, 'PCS', 'KAR', row.itemSpecifications)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "purchasingTotalNum",
                  title: "已要货数量(PCS)",
                  width: "150"
                }),
                _createVNode(_component_vxe_column, {
                  title: "剩余可要货数量(KAR)",
                  width: "150"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(convertToLargePackage)(row.unPurchasingTotalNum, 'PCS', 'KAR', row.itemSpecifications)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "unPurchasingTotalNum",
                  title: "剩余可要货数量(PCS)",
                  width: "150"
                }),
                _createVNode(_component_vxe_column, {
                  title: "换算关系",
                  width: "150"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(generateConvertRelationStr)(row.itemSpecifications)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemPurchasingNum",
                  title: "本次要货数量(PCS)",
                  width: "150",
                  "edit-render": { autofocus: 'input', placeholder: '请点击输入' }
                }, {
                  edit: _withCtx((scope) => [
                    _createVNode(_component_a_input_number, {
                      class: "oio-input-number",
                      value: scope.row.itemPurchasingNum,
                      "onUpdate:value": ($event: any) => ((scope.row.itemPurchasingNum) = $event),
                      min: 0,
                      step: 1,
                      style: {"width":"110px"},
                      onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (tableRef.value?.clearEdit()), ["enter"])),
                      controls: false
                    }, null, 8, ["value", "onUpdate:value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemShippedNum",
                  title: "已发货数量(PCS)",
                  width: "150"
                }),
                _createVNode(_component_vxe_column, {
                  title: "未发货数量(KAR)",
                  width: "150"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(convertToLargePackage)(row.itemUnShippedNum, 'PCS', 'KAR', row.itemSpecifications)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemUnShippedNum",
                  title: "未发货数量(PCS)",
                  width: "150"
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemCode",
                  title: "平台商品编码",
                  "min-width": "250"
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _createVNode(_component_vxe_pager, {
            style: {"flex":"none"},
            perfect: "",
            total: dataSource.value?.length,
            layouts: ['Total']
          }, null, 8, ["total"])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_unref(OioModal), {
      visible: showErrorModal.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((showErrorModal).value = $event)),
      title: "导入失败",
      width: "medium",
      class: "oio-modal",
      onOk: _cache[5] || (_cache[5] = ($event: any) => (showErrorModal.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_table, {
          border: "",
          height: "500",
          size: "mini",
          data: errorRows.value,
          "column-config": { resizable: true },
          "scroll-x": { enabled: false },
          "scroll-y": { enabled: true, gt: 0, oSize: 20 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_column, {
              field: "rowNum",
              title: "行号",
              width: "50"
            }),
            _createVNode(_component_vxe_column, {
              field: "itemName",
              title: "商品名称",
              "min-width": "250",
              "show-overflow": ""
            }),
            _createVNode(_component_vxe_column, {
              field: "errorMsg",
              title: "错误原因",
              "min-width": "250",
              "show-overflow": ""
            }),
            _createVNode(_component_vxe_pager, {
              style: {"flex":"none"},
              perfect: "",
              total: errorRows.value?.length,
              layouts: ['Total']
            }, null, 8, ["total"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 512))
}
}

})